<agpr-dialog-container
    [id]="'curatedAutoWebsocketDialog'"
    [heading]="autoGensStatus?.loading ?
        ('Briefings.blockType.autoGeninsights.mentionsLoadingHeader' | localize : {
            count: autoGensStatus?.count || 0, totalInsightsToComplete: autoGensStatus?.stats?.totalInsightsToComplete || 0
        }) :
        'Briefings.blockType.autoGeninsights.complete.header'
    "
    [showLoadingHeader]="autoGensStatus?.loading"
    [showClose]="autoGensStatus && !autoGensStatus?.loading"
    [hideFooter]="autoGensStatus?.loading"
    (close)="autoGensStatus && !autoGensStatus?.loading ? ok() : ''"
>
    <div
        class="agpr-curatedAutoWebsocketDialog-content"
    >
        @if (autoGensStatus?.loading) {
            <div class="agpr-curatedAutoWebsocketDialog-content-info">
                {{ 'Briefings.blockType.autoGeninsights.takeSeveralMinutes' | localize }}
            </div>

            <agpr-message [severity]="messageSeverityEnum.info">
                <ul class="agpr-briefing-errorList">
                    <li>
                        <agpr-button
                            [style]="buttonTypes.link"
                            [attr.aria-label]="'Briefings.blockType.autoGeninsights.continueWorking' | localize"
                            (click)="hide()"
                        >
                            {{ 'Briefings.blockType.autoGeninsights.hide' | localize }}
                        </agpr-button>
                        {{ 'Briefings.blockType.autoGeninsights.continueWorking' | localize }}
                    </li>
                    <li>
                        {{ 'Briefings.blockType.autoGeninsights.pleaseNote' | localize }}
                    </li>
                </ul>
            </agpr-message>
        } @else {
            <div class="agpr-curatedAutoWebsocketDialog-content-info" [innerHtml]="'Briefings.blockType.autoGeninsights.complete.message1' | localize"></div>
            <agpr-message [severity]="messageSeverityEnum.success">
                <span [innerHtml]="'Briefings.blockType.autoGeninsights.complete.message2' | localize : {successfulGenerations: autoGensStatus?.stats?.insightsCompleted}"></span>
            </agpr-message>
            @if (autoGensStatus?.stats?.notEnoughContentMentions > 0) {
                <agpr-message [severity]="messageSeverityEnum.warning">
                    <span [innerHtml]="'Briefings.blockType.autoGeninsights.complete.message3' | localize : {notEnoughContentGenerations: autoGensStatus?.stats?.notEnoughContentMentions}"></span>
                </agpr-message>
            }
            @if (autoGensStatus?.stats?.failedToGenerateInsightMentions > 0) {
                <agpr-message [severity]="messageSeverityEnum.error">
                    <span [innerHtml]="'Briefings.blockType.autoGeninsights.complete.message4' | localize : {failedGenerations: autoGensStatus?.stats?.failedToGenerateInsightMentions}"></span>
                </agpr-message>
            }
        }
    </div>

    @if (autoGensStatus && !autoGensStatus?.loading) {
        <ng-template #footerRight>
            <agpr-button
                [id]="'curatedAutoWebsocketDialog.ok'"
                [label]="'Briefings.blockType.autoGeninsights.acknowledge'"
                [style]="buttonTypes.primary"
                (click)="ok()"
            ></agpr-button>
        </ng-template>
    }
</agpr-dialog-container>
